/* eslint-disable import/no-cycle */

import React, { useContext, useEffect } from 'react';
import { FunctionField, ReferenceField, SelectField, TextField, useTranslate } from 'react-admin';
import resourceSlug from '../../constant/resource-slug';
import { transformIdValue } from '../../services/util/stringUtil';
import RewardFilterWrapper from './components/RewardList/RewardFilters';
import RewardActionWrapper from './components/RewardList/RewardActions';
import { REWARD_TYPES } from '../../constant/reward';
import RewardDetailsDrawer from './components/RewardDetailsDrawer';
import { NavigationContext } from '../../App';
import ActiveLabel from '../../base/components/ActiveLabel';
import RewardCreateUpdateDrawer from './components/RewardCreateUpdateDrawer';
import { CustomizedNoPageList } from '../../base/components/customized/CustomizedNoPageList';
import { useRewardTabSync } from './hooks/useRewardTabSync';

const RewardList = (props) => {
  const t = useTranslate();
  const { setNavigationData } = useContext(NavigationContext);

  const { setRewardTab } = useRewardTabSync();

  useEffect(() => {
    setNavigationData({
      pageTitleInfo: {
        label: t('resources.reward.name'),
      },
    });

    return () => {
      setNavigationData({});
    };
  }, [t]);

  return (
    <>
      <CustomizedNoPageList
        {...props}
        filters={<RewardFilterWrapper />}
        actions={<RewardActionWrapper />}
        disabledAutoRefetch
        rowClick={(id) => {
          setRewardTab(id, 'view');
        }}
        syncWithLocation
      >
        <FunctionField label="common.fields.id" render={(record) => transformIdValue(record.id)} />
        <TextField source="rewardName" label="resources.reward.fields.name" sortable={false} />
        <SelectField
          source="rewardType"
          label="resources.reward.fields.reward-type"
          choices={Object.values(REWARD_TYPES).map((type) => ({
            id: type,
            name: t(`resources.reward.reward-type.${type}`),
          }))}
          sortable={false}
        />
        <ReferenceField
          label="resources.reward.fields.currency"
          sortable={false}
          reference={resourceSlug.CURRENCY}
          source="currencyId"
          link={false}
        >
          <FunctionField render={(record) => `${record.name} (${record.code})`} />
        </ReferenceField>
        <FunctionField
          label="resources.reward.fields.expiry"
          render={(record) =>
            t(`resources.reward.expiry.${record.validPeriodUnit}`, {
              smart_count: record.validPeriod,
            })
          }
        />
        <FunctionField
          source="isEnabled"
          label="resources.reward.fields.status"
          render={(record) => <ActiveLabel isActive={record.isEnabled} />}
          {...props}
        />
      </CustomizedNoPageList>
      <RewardCreateUpdateDrawer />
      <RewardDetailsDrawer />
    </>
  );
};

export default RewardList;
